module.exports = __webpack_public_path__ + "static/media/mobile_wd_page_area03_img_cn.c7f230db.png";